exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-price{font-weight:700;margin:0}.product-price .compared-price{color:#a20707;margin-left:10px;text-decoration:line-through}", ""]);

// exports
